import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getSearchInfo } from '../../../../services/api';
import SearchResItem from './searchResItem';
import NoSearchResTips from './noSearchResTips';
import Chip from 'Chip';

/**
 * 定义 Input 组件
 */
class Input extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        searchValue: '',
        searchBtnActive: false,
        searchResList: [],
        noInfoShow: false,
    };

    asyncGetSearchInfo = async searchInfo => {
        if (searchInfo) {
            try {
                const res = await getSearchInfo(searchInfo);

                if (res && res.data.length !== 0) {
                    const { data } = res;

                    console.log(data);

                    this.setState({
                        searchResList: data,
                    });
                } else {
                    this.setState({
                        searchResList: [],
                        noInfoShow: true,
                    });
                }
            } catch (error) {
                alert(error.message);
            }
        }
    };

    onChange = e => {
        this.setState({
            searchValue: e.target.value,
            noInfoShow: false,
        });

        if (!e.target.value) {
            this.setState({
                searchBtnActive: false,
                searchResList: [],
                noInfoShow: false,
            });
        } else {
            this.setState({
                searchBtnActive: true,
            });
        }
    };

    onSearch = () => {
        const { searchValue } = this.state;

        this.asyncGetSearchInfo(searchValue);
    };

    onKeyDown = e => {
        this.setState({
            searchBtnActive: true,
        });

        const { searchValue } = this.state;

        if (Number(e.keyCode) === 13) {
            this.asyncGetSearchInfo(searchValue);
        }
    };

    render() {
        const { content } = this.props;
        const { noSearchResTips } = content;

        const { searchBtnActive, searchResList, noInfoShow } = this.state;

        return (
            <div className={styles.inputContainer}>
                <img
                    src="//x0.ifengimg.com/ucms/2021_36/2A8D635A5C98D210BC0EFA50822AD01B3E3B5D48_size16_w352_h46.png"
                    alt=""
                />
                <div className={styles.text}>凤凰网地方频道人员查询系统</div>
                <div className={styles.input}>
                    <span className={styles.search_icon} />
                    <input
                        type="text"
                        placeholder="输入姓名或手机号"
                        onChange={this.onChange}
                        onKeyDown={this.onKeyDown}
                    />
                </div>
                <div className={searchBtnActive ? styles.searchActive : styles.search} onClick={this.onSearch}>
                    搜索
                </div>
                {searchResList.length !== 0 ? <SearchResItem content={searchResList} /> : null}
                {noInfoShow ? (
                    <div>
                        <Chip id="220686" type="static" title="查无此项" groupName="搜索页" content={noSearchResTips}>
                            <NoSearchResTips />
                        </Chip>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default errorBoundary(Input);
